import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../services/index';
import { ChangeRequest } from '../../models/change-request.model';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-change-request-list',
  styleUrls: ['../defis/defi-list.component.scss'],
  templateUrl: './change-request-list.component.html',
})
export class ChangeRequestListComponent implements OnInit {
  // font awesome
  public faEdit = faEdit;

  // loading indicator
  loading = false;

  @ViewChild('submittedItemTmpl', { static: true })
  submittedItemTmpl: TemplateRef<any>;
  @ViewChild('editItemTmpl', { static: true }) editItemTmpl: TemplateRef<any>;

  // column definition
  columns;

  data: Array<ChangeRequest>;

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.columns = [
      { prop: 'requestId', name: 'Id', width: 10 },
      {
        prop: 'submitted',
        name: 'Submitted',
        cellTemplate: this.submittedItemTmpl,
        width: 70,
      },
      { prop: 'defi.name', name: 'Name', width: 700 },
      { name: 'Actions', cellTemplate: this.editItemTmpl, width: 20 },
    ];

    // indicate loading
    this.loading = true;

    // load data
    this.loadData();
  }

  private loadData() {
    // load data (take, skip)
    this.api.getDefiChangeRequests().subscribe((response) => {
      // store the data
      this.data = new Array<ChangeRequest>();
      for (const entry of response) {
        this.data.push(new ChangeRequest().deserialize(entry));
      }

      // loading finished
      this.loading = false;
    });
  }
}
